<div
  style="
    height: 128px;
    display: flex;
    justify-content: center;
    align-items: center;
  ">
  <span class="loader" [ngStyle]="{ border: '3px solid ' + color }"></span>
</div>
